import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

import clickThoughPageImage from 'assets/images/splashPage/click_though_page.png';

// Components
import ModalContainer from 'components/ModalContainer';

const PreviewModal = ({ openPreviewModal, setOpenPreviewModal }) => {
  const theme = useTheme();

  return (
    <ModalContainer display={openPreviewModal} modalWidth="850px">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '0 0 10px 20px',
        }}
      >
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.customFontSize[5],
            fontWeight: theme.typography.customFontWeight[3],
          }}
        >
          Preview
        </Typography>
        <Button
          onClick={() => setOpenPreviewModal(false)}
          sx={{
            backgroundColor: theme.palette.primary.transparent,
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: theme.palette.primary.transparent,
            },
          }}
        >
          <CloseIcon />
        </Button>
      </Box>
      <Box sx={{ overflow: 'scroll' }}>
        <Box
          component="img"
          src={clickThoughPageImage}
          alt="example"
          sx={{
            width: 700,
            display: 'block',
            mx: 'auto',
          }}
        />
      </Box>
    </ModalContainer>
  );
};

export default PreviewModal;
